import React from "react";
import InfoSection from "./InfoSection";
import EditableInfoRow from "./EditableInfoRow";

const UNIT_OF_MEASUREMENT_OPTIONS = [
    { id: "sq_ft",   name: "Square Feet (sq. ft.)" },
    { id: "sq_m",    name: "Square Meters (sq. m.)" },
    { id: "sq_yd",   name: "Square Yards (sq. yd.)" },
    { id: "acre",    name: "Acre" },
    { id: "hectare", name: "Hectare" },
];

const UNIT_SUFFIX = {
    sq_ft:   "sq. ft.",
    sq_m:    "sq. m.",
    sq_yd:   "sq. yd.",
    acre:    "acres",
    hectare: "hectares",
};

const PropertyDetails = ({ data, isEditing, isLoading, onEdit, onSave, onCancel, onChange }) => {
    const propertyDetails = data || {};

    const unitKey = propertyDetails.unitOfMeasurement;
    const unitSuffix = UNIT_SUFFIX[unitKey] || "";
    const carpetAreaDisplay = propertyDetails.totalCarpetArea
        ? `${propertyDetails.totalCarpetArea}${unitSuffix ? ` ${unitSuffix}` : ""}`
        : "";

    return (
        <InfoSection
            title="Property Details"
            icon="solar:home-angle-bold"
            isEditing={isEditing}
            isLoading={isLoading}
            onEdit={onEdit}
            onSave={onSave}
            onCancel={onCancel}
        >
            <div className="row">
                <EditableInfoRow
                    label="Unit of Measurement"
                    value={propertyDetails.unitOfMeasurement}
                    displayValue={UNIT_OF_MEASUREMENT_OPTIONS.find(o => o.id === unitKey)?.name || "-"}
                    icon="solar:ruler-cross-pen-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="unitOfMeasurement"
                    onChange={onChange}
                    type="select"
                    options={UNIT_OF_MEASUREMENT_OPTIONS}
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select unit"
                />
                <EditableInfoRow
                    label="Total Carpet Area"
                    value={propertyDetails.totalCarpetArea}
                    displayValue={carpetAreaDisplay}
                    icon="solar:ruler-angular-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="totalCarpetArea"
                    onChange={onChange}
                    placeholder={`Enter total carpet area${unitSuffix ? ` in ${unitSuffix}` : ""}`}
                />
                <EditableInfoRow
                    label="Total Water Inlets"
                    value={propertyDetails.totalWaterInlets}
                    icon="solar:water-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="totalWaterInlets"
                    onChange={onChange}
                    placeholder="Enter total water inlets"
                />
            </div>
        </InfoSection>
    );
};

export default PropertyDetails;
